import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showNavBar: true,
    showFooter: true,
    userLogged: false
  },
  mutations: {
    hideNavAndFooter (state) {
      state.showNavBar = false
      state.showFooter = false
    },
    showNavAndFooter (state) {
      state.showNavBar = true
      state.showFooter = true
    },
    loginUser (state) {
      state.userLogged = true
    },
    logoutUser (state) {
      state.userLogged = false
    }
  },
  actions: {

  }
})
